import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import { filter, map, Observable, startWith, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';

import { CmsPageService, LoaderType } from '@fcom/common';
import { unsubscribe } from '@fcom/core/utils';
import { RootPaths } from '@fcom/core/constants';
import { finShare } from '@fcom/rx';
import { filterWithoutType, findByType } from '@fcom/cms';
import { CmsCollection, CmsImageData, CmsTemplate, CmsViewType } from '@fcom/core-api/interfaces';
import { getBackgroundImageForCmsTemplate } from '@fcom/cms/services/cms-utils/cms-utils';
import { QualtricsSurveys } from '@fcom/common/qualtrics/qualtrics.utils';
import { FeedbackService } from '@fcom/common/services/feedback/feedback.service';

import { ManageBookingFeatureState } from '../../../interfaces';
import { getLoading } from '../../../store/selectors';

@Component({
  selector: 'fin-check-in-entry-route',
  templateUrl: 'check-in-entry-route.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckInEntryRouteComponent implements OnInit, OnDestroy {
  readonly LoaderType = LoaderType;

  loading$: Observable<boolean>;
  template$: Observable<{ loading: boolean; data: CmsTemplate }>;
  backgroundImage$: Observable<CmsImageData>;
  disruptions$: Observable<CmsCollection>;
  mainContent$: Observable<CmsTemplate>;

  private subscription = new Subscription();
  constructor(
    private pageService: CmsPageService,
    private store$: Store<ManageBookingFeatureState>,
    private feedbackService: FeedbackService
  ) {}

  ngOnInit(): void {
    this.feedbackService.setSurvey(QualtricsSurveys.CHECK_IN);
    this.feedbackService.setFeedbackWidgetVisibility(true);

    this.template$ = this.pageService
      .getPageDataAndSetMeta(RootPaths.CHECK_IN_ROOT, RootPaths.MANAGE_BOOKING_ROOT)
      .pipe(
        map((data) => ({ loading: false, data })),
        startWith({ loading: true, data: null }),
        finShare()
      );

    const contents$ = this.template$.pipe(
      filter((template) => Boolean(template.data)),
      map((template) => template.data)
    );
    this.mainContent$ = contents$.pipe(filterWithoutType(CmsViewType.DISRUPTIONS, 'main'));
    this.disruptions$ = contents$.pipe(
      map((c) => c.main),
      findByType(CmsViewType.DISRUPTIONS, false)
    );

    this.backgroundImage$ = getBackgroundImageForCmsTemplate(this.template$.pipe(map((t) => t.data)));

    this.loading$ = this.store$.pipe(getLoading());
  }

  ngOnDestroy(): void {
    unsubscribe(this.subscription);
    this.feedbackService.setFeedbackWidgetVisibility(false);
  }
}
